import { useState } from "react";
import api from "../api/api";
import { Link } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleLogin(e) {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    // 🚀 O SEGREDO: Transformando os dados em formulário (padrão OAuth2)
    const params = new URLSearchParams();
    params.append('username', email); // O FastAPI exige 'username' para o login padrão
    params.append('password', password);

    try {
      // 🛡️ Enviando com o Header correto para formulário
      const res = await api.post("/auth/login", params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });

      localStorage.setItem("token", res.data.access_token);
      localStorage.setItem("user_name", res.data.user_name);
      localStorage.setItem("user_role", res.data.role); 
      window.location.href = "/dashboard"; 
    } catch (err) {
      // 🛡️ TRATAMENTO DE ERRO: Garante que o React receba apenas TEXTO, não um objeto
      const errorDetail = err.response?.data?.detail;
      
      if (Array.isArray(errorDetail)) {
        // Se o FastAPI retornar uma lista de erros (como o 422), pegamos a primeira mensagem
        setError(errorDetail[0]?.msg || "Erro na validação dos dados.");
      } else if (typeof errorDetail === "string") {
        // Se for o erro 401 que configuramos manualmente
        setError(errorDetail);
      } else {
        setError("Acesso negado. Credenciais inválidas.");
      }
    } finally { 
      setIsLoading(false); 
    }
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[#070913] relative overflow-hidden">
      <div className="absolute top-[-20%] left-[-10%] w-[600px] h-[600px] bg-indigo-600/20 blur-[150px] rounded-full pointer-events-none animate-pulse"></div>

      <div className="w-full max-w-md p-10 bg-slate-900/60 backdrop-blur-2xl rounded-[40px] border border-white/10 shadow-2xl animate-in zoom-in duration-700 relative z-10">
        <div className="text-center mb-10">
          <div className="w-24 h-24 bg-gradient-to-br from-slate-800 to-slate-950 border border-white/10 rounded-[30px] mx-auto mb-6 flex items-center justify-center text-white text-3xl font-black shadow-2xl shadow-black/50">
            
          </div>
          <h1 className="text-4xl font-black text-white tracking-tighter">Login <span className="text-indigo-500">Dash</span></h1>
          <p className="text-[10px] text-slate-500 font-black uppercase tracking-[0.4em] mt-3 ml-2 flex items-center justify-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-ping"></span> Sistema Restrito
          </p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div className="space-y-1">
            <label className="text-[9px] font-black text-indigo-400 uppercase ml-2 tracking-widest">Identificação</label>
            <input 
              type="email" 
              placeholder="admin@tecnico.com.br" 
              required 
              className="w-full p-5 bg-slate-950/50 border border-white/5 rounded-2xl text-white font-bold outline-none focus:border-indigo-500 transition-all placeholder:text-slate-700" 
              onChange={e => setEmail(e.target.value)} 
            />
          </div>

          <div className="space-y-1">
            <label className="text-[9px] font-black text-indigo-400 uppercase ml-2 tracking-widest">Senha de Segurança</label>
            <input 
              type="password" 
              placeholder="••••••••" 
              required 
              className="w-full p-5 bg-slate-950/50 border border-white/5 rounded-2xl text-white font-bold outline-none focus:border-indigo-500 transition-all placeholder:text-slate-700" 
              onChange={e => setPassword(e.target.value)} 
            />
          </div>

          {error && (
            <div className="bg-rose-500/10 p-3 rounded-xl">
              <p className="text-rose-400 text-[10px] font-black text-center uppercase tracking-widest">
                {error}
              </p>
            </div>
          )}

          <button 
            type="submit" 
            disabled={isLoading} 
            className="w-full py-5 bg-indigo-600 hover:bg-indigo-500 text-white font-black rounded-2xl shadow-xl shadow-indigo-600/30 transition-all active:scale-95 uppercase text-xs tracking-widest"
          >
            {isLoading ? "Validando Token..." : "Entrar no Sistema →"}
          </button>
        </form>
        
        <div className="mt-8 text-center border-t border-white/5 pt-6">
          <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
            Sem acesso? <Link to="/registro" className="text-indigo-400 hover:text-indigo-300 underline transition-colors ml-1">Criar Conta Técnica</Link>
          </p>
        </div>
      </div>
    </div>
  );
}